
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/profile/manage-subscription",
      function () {
        return require("private-next-pages/[locale]/profile/manage-subscription/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/profile/manage-subscription"])
      });
    }
  